<template>
  <div class="login__form">
    <v-layout>
      <v-flex xs12>
        <v-card class="pa-0">
          <v-alert
            v-model="error"
            class="ma-0"
            dismissible
            type="error"
          >
            {{errorMsg}}
          </v-alert>
          <div class="px-4 py-4">
            <v-card-title primary-title class="px-0 pt-0">
              <div>
                <div class="headline">Resetuj hasło</div>
              </div>
            </v-card-title>
            <div>
              <v-text-field
                v-model.trim="formData.email"
                label="Adres e-mail"
                :error-messages="errors.collect('email')"
                v-validate="'email|required'"
                data-vv-name="email"
                data-vv-as="adres e-mail"
                required
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                v-model.trim="formData.password"
                ref="password_confirmation"
                label="Hasło"
                :type="'password'"
                :error-messages="errors.collect('password')"
                v-validate="'required|min:6|max:20'"
                data-vv-name="password"
                data-vv-as="hasło"
                hint="Hasło musi mieć od 6 do 20 znaków, musi zawierać co najmniej:
                jedną małą literę, jedną wielką literę, jedną liczbę oraz jeden znak specjalny"
                required
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                v-model.trim="formData.password_confirmation"
                label="Powtórz hasło"
                :type="'password'"
                :error-messages="errors.collect('password_confirmation')"
                v-validate="'required|min:6|max:20|confirmed:password_confirmation'"
                data-vv-name="password_confirmation"
                data-vv-as="powtórz hasło"
                required
              ></v-text-field>
            </div>
            <v-card-actions class="px-0">
              <v-layout align-center>
                <v-flex xs6>
                  <router-link class="primary--text" to="/login">
                    Logowanie
                  </router-link>
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                  <v-btn
                    color="primary"
                    :loading="busy"
                    :disabled="busy"
                    @click="submitForm"
                  >Wyślij</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
            <ServerErrors :errorsItems="serverErrors" />
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getError } from '../../helpers/helpers';
import { resetPassword } from '../../repository/auth';
import ServerErrors from '../common/Errors/ServerErrors.vue';

export default {
  name: 'reset-password-form',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    serverErrors: [],
    formData: {
      token: null,
      email: null,
      password: null,
      password_confirmation: null,
    },
  }),
  components: {
    ServerErrors,
  },
  methods: {
    ...mapActions('app', [
      'setSnackBar',
    ]),
    clearData() {
      this.$validator.reset();
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
      this.formData = {
        token: null,
        email: null,
        password: null,
        password_confirmation: null,
      };
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.passwordReset();
        }
      });
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    async passwordReset() {
      this.busy = true;
      try {
        this.formData.token = this.$route.params.token;
        const resetRes = await resetPassword(this.formData);
        this.setSnackBar(resetRes.data.status.msg);
        this.$router.push('/');
        this.busy = false;
        this.clearData();
      } catch (e) {
        this.getError(e);
      }
    },
  },
};
</script>
